import { observable, action } from 'mobx';
import gql from 'graphql-tag';

const FloorAreaMutation = gql`
    mutation FloorAreaMutation(
        $URLID: String!
        $FloorArea: String!
        $Stairwells: Int!
    ) {
        toolSubmissionMutation(
            URLID: $URLID
            FloorArea: $FloorArea
            Stairwells: $Stairwells
        ) {
            URLID
            Error
        }
    }
`;

export class FloorAreaStore {
    appStore;

    @observable goNext = false;

    @observable loading = false;

    @observable isReadOnly = false;

    @action reset() {
        this.goNext = false;
        this.loading = false;
        this.isReadOnly = false;
    }

    constructor(opts) {
        this.appStore = opts.appStore;
        this.currentRoomNum = opts.currentRoomNum;
    }

    @action setIsReadOnly(value) {
        this.isReadOnly = value;
    }

    getMutation(values) {
        return {
            mutation: FloorAreaMutation,
            variables: {
                URLID: this.appStore.submissionID,
                FloorArea: JSON.stringify(values),
                Stairwells: parseInt(this.appStore.stairwells, 10)
            },
            fetchPolicy: 'no-cache',
            context: {
                headers: {
                    'X-CSRF-TOKEN': this.appStore.sectoken
                }
            }
        };
    }

    async save(values, form, goNext) {
        this.loading = true;
        this.appStore.updateUserData(values, 'floorarea', false);
        this.appStore.save(this.getMutation(values), this, form, goNext);
    }
}
